import { DateOrISOString } from 'types/date';
import { formatDate } from 'utils/dateUtils';

interface IFormatDateWithTimezoneParams {
  date: DateOrISOString;
  timeZone: string;
  dateFormat: string;
}

export const formatDateWithTimezone = ({
  date,
  timeZone,
  dateFormat,
}: IFormatDateWithTimezoneParams) => {
  const dateObj = new Date(date);
  const timezoneDate = new Date(dateObj).toLocaleString('en-US', {
    timeZone,
  });
  const formattedDate = formatDate(new Date(timezoneDate), dateFormat);
  return formattedDate;
};

export const calculateDateWithTimeZone = (
  date: DateOrISOString,
  timeZone: string,
) => {
  const dateObj = new Date(date);
  const timezoneDate = new Date(dateObj).toLocaleString('en-US', {
    timeZone,
  });
  return new Date(timezoneDate);
};
